import { render, staticRenderFns } from "./WaLink.vue?vue&type=template&id=54f32de3"
import script from "./WaLink.vue?vue&type=script&lang=js"
export * from "./WaLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports